/** Loading placeholder for a team-scoped list: a few skeleton rows (skeletons
 *  over a mid-content spinner). `label` names what is loading. */
export function ListSkeleton({ label }: { label: string }) {
  return (
    <div role="status" aria-label={label} className="flex flex-col gap-2">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="h-5 w-full animate-pulse rounded bg-line" />
      ))}
    </div>
  )
}
